<template>
  <Container>
    <Breadcrumbs />

    <div
      class="
        grid grid-cols-2 gap-15
        lg:grid-cols-3
      "
    >
      <!-- MAIN CONTENT -->
      <div class="col-span-2">
        <!-- Category -->
        <p v-if="page.news_category" class="mb-2 text-sm text-gray-500">
          {{ page.news_category.title }}
        </p>

        <div class="mb-2 flex items-center gap-5">
          <!-- Date -->
          <time class="font-semibold" :datetime="page.date">{{ dateFormatted }}</time>
          <!-- Publisher -->
          <p v-if="publisher" class="text-gray-500">
            {{ publisher }}
          </p>
        </div>

        <HeroDefault
          :data="{
            heading: page.heading,
            text: page.text,
            image: page.image,
            copyright: page.copyright,
            links: links,
          }"
        />

        <LoaderComponents
          v-editor-target="'main_components'"
          :components="page.main_components"
        />
      </div>

      <!-- SIDEBAR -->
      <div class="max-lg:col-span-2">
        <LoaderComponents
          v-editor-target="'sidebar_components'"
          class="space-y-7"
          :components="page.sidebar_components"
        />
      </div>
    </div>
  </Container>
</template>

<script setup lang="ts">
import type { BlueprintNewsArticleFragment } from '#gql'

const props = defineProps<{ page: Enforce<BlueprintNewsArticleFragment> }>()

const {
  t, locale, locales,
} = useI18n()

const dateFormatted = computed(() => {
  if (!props.page.date) return

  const dateObj = new Date(props.page.date)

  const options = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  }

  // Find the locale in the list of available locales by code
  const localeObj = locales.value.find(site => site.code === locale.value)

  return dateObj.toLocaleDateString(localeObj?.language || 'de-CH', options)
})

// Merge external link with other links
const links = computed(() => {
  const externalLink = {
    link: props.page.link_external,
    link_text: t('more'),
  }

  return [
    externalLink,
    ...props.page.links,
  ]
})

const publisher = computed(() => {
  if (props.page.publisher) {
    return props.page.publisher.title
  }

  return props.page.site_attributes.find(attr => attr.key === 'title')?.value
})
</script>
